<template>
  <!-- Hidden Camera input element (with capture for camera) -->
  <input
    ref="cameraInputRef"
    type="file"
    :accept="acceptedType"
    :capture="captureType"
    :multiple="multiple"
    style="display: none"
    @change="onFileChange"
  />
  <!-- Hidden Gallery input element (without capture for gallery) -->
  <input
    ref="galleryInputRef"
    type="file"
    :accept="acceptedType"
    :multiple="multiple"
    style="display: none"
    @change="onFileChange"
  />
</template>

<script>
  import { defineComponent, ref } from "vue";

  export default defineComponent({
    name: "CameraInput",
    props: {
      captureType: {
        type: String,
        default: "environment" // Use rear camera by default
      },
      acceptedType: {
        type: String,
        default: "image/*" // Default to accepting image files
      },
      multiple: {
        type: Boolean,
        default: true // Default to allowing multiple file selection
      }
    },
    emits: ["file-selected"],
    setup(_, { emit }) {
      const cameraInputRef = ref(null);
      const galleryInputRef = ref(null);

      // Legacy method - triggers camera input (for backward compatibility)
      const triggerFileInput = () => {
        cameraInputRef.value?.click();
      };

      // Trigger camera input specifically
      const triggerCamera = () => {
        cameraInputRef.value?.click();
      };

      // Trigger gallery input specifically
      const triggerGallery = () => {
        galleryInputRef.value?.click();
      };

      const onFileChange = (event) => {
        emit("file-selected", event);
      };

      // Method to reset the input value
      const resetInput = () => {
        if (cameraInputRef.value) {
          cameraInputRef.value.value = "";
        }
        if (galleryInputRef.value) {
          galleryInputRef.value.value = "";
        }
      };

      return {
        cameraInputRef,
        galleryInputRef,
        triggerFileInput,
        triggerCamera,
        triggerGallery,
        onFileChange,
        resetInput
      };
    }
  });
</script>
